exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.editarTime .h2_title[data-v-a45ab890] {\n  font-weight: normal;\n}\n#cardDivTV[data-v-a45ab890] {\n  width: 100%;\n}\n", ""]);

// exports
